module.exports = __webpack_public_path__ + "img/floor_hl.2ba4e616.png";